<template>
  <li
    :data-gtm="theme?.subtitle"
    class="
      dvg-map-gallery-card
      layout/flex:column
      link/cursor
    "
    @click="handleClick"
    >
    <div
      class="
        @600/layout/width:min
        layout/ratio:3:2
        layout/width:min"
      style="
        --600--layout--width--min: 8.9rem;
        --layout--width--min: 14.4rem;
      "
      >
      <picture class="picture">
        <img
          class="
            picture/image:crop
          "
          :src="theme?.Asset?.URL"
          :alt="theme.subtitle"
        >
      </picture>
    </div>
    <div class="layout/margin:top:baseline">
      <p
        v-if="currentStatus"
        class="
          $color/session
          $typography/size:medium
          color
          typography
        "
        v-html="currentStatus"
      />
      <p
        class="
          $typography/size:medium
          typography
        "
        v-html="themeSubtitle"
      />
      <p
        class="
          $color/gray:767
          $typography/size:medium
          color
          typography
        "
        >
        Gallery {{ theme?.title }}
      </p>
    </div>
  </li>
</template>

<script>
  import { marked } from 'marked';
  import DOMPurify from 'dompurify';
  import { getGalleryOverlayData, getGalleryStatus } from 'Helpers/dvg-helpers/map-page-helpers';
  export default {
    props: { 
      theme: {
        type: Object,
        required: true
      },
      setHighlightedElement: {
        type: Function,
        required: true
      },
      showDrawer: {
        type: Function,
        required: true
      }
    },
    computed: {
      themeLink() {
        return `/calendar/galleries/${this.theme.id}`;
      },
      themeSubtitle() {
        const html = marked.parse(this.theme?.subtitle);
        return DOMPurify.sanitize(html);
      },
      currentStatus() {
        return getGalleryStatus(this.theme);
      }
    },
    methods: {
      handleClick() {
        this.setHighlightedElement(this.theme.title);
        this.showDrawer(getGalleryOverlayData(this.theme));
      }
    }
  };
</script>